import { Dictionary } from "lodash";
import React, { type ReactElement } from "react";
import { GlossaryNavItem } from "@/components";
import { Tag } from "@/types";

interface GlossaryNavProps {
  tags: Dictionary<Tag[]>;
}

function GlossaryNav({ tags }: Readonly<GlossaryNavProps>): ReactElement {
  const alphabet = "abcdefghijklmnopqrstuvwxyz".split("");

  return (
    <nav className="sticky z-10 top-(--globalnav-height) h-14 flex flex-row items-center justify-start border-b border-border bg-background">
      <ul className="max-w-7xl mx-auto px-4 flex-1 flex flex-row items-start justify-start gap-1 overflow-y-auto">
        {alphabet.map((letter) => {
          const counter = tags[letter] ? tags[letter].length : 0;
          return (
            <GlossaryNavItem key={letter} letter={letter} counter={counter} />
          );
        })}
      </ul>
    </nav>
  );
}

export { GlossaryNav, type GlossaryNavProps };
